import { render, staticRenderFns } from "./CreateDirectorySidePanel.vue?vue&type=template&id=404bd5a4&"
import script from "./CreateDirectorySidePanel.vue?vue&type=script&lang=ts&"
export * from "./CreateDirectorySidePanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports